document.addEventListener('DOMContentLoaded',()=>{
  const q=(s,r=document)=>r.querySelector(s);
  const qa=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const root=q('.vl-root');
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine=window.matchMedia('(pointer:fine)').matches;

  // Mobile navigation
  const menu=q('[data-vl-menu]');
  const links=q('[data-vl-links]');
  if(menu&&links){
    menu.addEventListener('click',()=>{
      const open=links.classList.toggle('is-open');
      menu.setAttribute('aria-expanded',open?'true':'false');
      document.body.style.overflow=open?'hidden':'';
    });
    qa('a',links).forEach(a=>a.addEventListener('click',()=>{
      links.classList.remove('is-open');
      menu.setAttribute('aria-expanded','false');
      document.body.style.overflow='';
    }));
  }

  // Active route + dropdown hygiene
  qa('[data-vl-links] a').forEach(a=>{if(a.pathname===location.pathname)a.classList.add('is-active')});
  document.addEventListener('click',e=>{
    qa('.vl-navgroup[open]').forEach(d=>{if(!d.contains(e.target))d.removeAttribute('open')});
  });

  // Footer year
  qa('[data-vl-year]').forEach(e=>e.textContent=new Date().getFullYear());

  // Scroll progress + nav state + parallax
  const progress=q('[data-vl-progress]');
  const nav=q('[data-vl-nav]');
  let latestScroll=0;
  let raf=false;
  const updateScroll=()=>{
    const h=document.documentElement;
    const max=h.scrollHeight-h.clientHeight;
    if(progress)progress.style.width=(max?Math.min(100,h.scrollTop/max*100):0)+'%';
    if(nav)nav.classList.toggle('is-scrolled',h.scrollTop>24);
    if(root&&!reduce)root.style.setProperty('--vl-parallax-y',Math.min(h.scrollTop*0.045,32).toFixed(1)+'px');
    raf=false;
  };
  addEventListener('scroll',()=>{
    latestScroll=window.scrollY;
    if(!raf){requestAnimationFrame(updateScroll);raf=true}
  },{passive:true});
  updateScroll();

  // Cursor-driven ambient background
  if(root&&fine&&!reduce){
    window.addEventListener('pointermove',e=>{
      root.style.setProperty('--vl-mx',(e.clientX/window.innerWidth*100).toFixed(1)+'%');
      root.style.setProperty('--vl-my',(e.clientY/window.innerHeight*100).toFixed(1)+'%');
    },{passive:true});
  }

  // Staggered reveal
  qa('.vl-reveal').forEach((el,i)=>el.style.setProperty('--vl-delay',Math.min((i%6)*45,225)+'ms'));
  if('IntersectionObserver'in window&&!reduce){
    const io=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(entry.isIntersecting){entry.target.classList.add('is-in');io.unobserve(entry.target)}
    }),{threshold:.09,rootMargin:'0px 0px -5% 0px'});
    qa('.vl-reveal').forEach(el=>io.observe(el));
  }else{
    qa('.vl-reveal').forEach(el=>el.classList.add('is-in'));
  }

  // Count-up animation
  if('IntersectionObserver'in window&&!reduce){
    const ci=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      const el=entry.target;
      const target=parseInt(el.dataset.vlCountup||el.textContent,10);
      if(Number.isNaN(target))return;
      const pad=(el.dataset.vlCountup==='6'||el.dataset.vlCountup==='1')?2:0;
      const start=performance.now();
      const duration=900;
      const tick=now=>{
        const p=Math.min(1,(now-start)/duration);
        const eased=1-Math.pow(1-p,3);
        let v=Math.round(target*eased).toString();
        if(pad)v=v.padStart(pad,'0');
        el.textContent=v;
        if(p<1)requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      ci.unobserve(el);
    }),{threshold:.5});
    qa('[data-vl-countup]').forEach(el=>ci.observe(el));
  }

  // Subtle tilt on hero/test cards (desktop only)
  if(fine&&!reduce){
    qa('[data-vl-tilt]').forEach(el=>{
      el.addEventListener('pointermove',e=>{
        const r=el.getBoundingClientRect();
        const x=(e.clientX-r.left)/r.width-.5;
        const y=(e.clientY-r.top)/r.height-.5;
        el.style.transform='perspective(1000px) rotateX('+(-y*3.4).toFixed(2)+'deg) rotateY('+(x*4.2).toFixed(2)+'deg) translateY(-2px)';
      });
      el.addEventListener('pointerleave',()=>{el.style.transform=''});
    });
  }

  // Click ripple
  document.addEventListener('pointerdown',e=>{
    const btn=e.target.closest('.vl-btn,.vl-navcta');
    if(!btn||reduce)return;
    const rect=btn.getBoundingClientRect();
    const size=Math.max(rect.width,rect.height);
    const ripple=document.createElement('span');
    ripple.className='vl-ripple';
    ripple.style.width=ripple.style.height=size+'px';
    ripple.style.left=(e.clientX-rect.left-size/2)+'px';
    ripple.style.top=(e.clientY-rect.top-size/2)+'px';
    btn.appendChild(ripple);
    setTimeout(()=>ripple.remove(),650);
  });

  // Challenge interaction
  const challenge=q('[data-vl-challenge]');
  const result=q('#vl-trust-result');
  if(challenge&&result){
    const timer=q('[data-vl-demo-timer]');
    const timerNumber=q('[data-vl-demo-seconds]');
    let left=10;
    let timerId=null;
    if(timer&&timerNumber&&!reduce){
      timerId=setInterval(()=>{
        left-=1;
        timerNumber.textContent=String(Math.max(0,left));
        if(left<=0){clearInterval(timerId);timer.classList.add('is-done')}
      },1000);
    }
    qa('[data-vl-choice]',challenge).forEach(b=>b.addEventListener('click',()=>{
      if(timerId)clearInterval(timerId);
      const choice=b.getAttribute('data-vl-choice');
      const heading=q('[data-vl-result-heading]',result);
      if(heading)heading.textContent='You chose Experience '+choice+'.';
      result.hidden=false;
      qa('[data-vl-choice]',challenge).forEach(x=>x.disabled=true);
      result.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
    },{once:true}));
  }
});